import styles from './index.scss';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginBasicBox from '@/components/auth/login-basic-box/login-basic-box';
import { Button } from 'react-bootstrap';
import { useLevvelTranslation } from '@/hooks/useLevvelTranslation';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

// Expired reset link (ADR-2, approved visible change #3).
//
// "Resend" used to decode the account out of the link
// (`JSON.parse(atob(signature)).Account`) and fire the request from here. ADR-2
// removed the account name from the link payload deliberately: a reset link sits
// in a mailbox and can be forwarded, logged or cached by a proxy, so it must not
// identify its owner. That leaves this page with no username to resend for — and
// it cannot ask the server either, since the user is here precisely because the
// token's Redis key no longer exists.
//
// So the button navigates back to /forgot-password and the user retypes the
// username. The page also no longer requires any query param: with the account
// gone there is nothing here worth validating, and the old `?signature=` guard
// would now bounce every visitor straight back out.
const LinkExpired = () => {
  const navigate = useNavigate();
  const { lt } = useLevvelTranslation();

  const handleResend = () => {
    navigate('/forgot-password');
  };

  return (
    <LoginBasicBox>
      <main className={styles.box}>
        <div className={styles.info}>
          <h3 className={cx(['title-bold', 'infoTitle'])}>
            {lt('cdb_forgot_password_expired_title')}
          </h3>
          <p className={styles.infoDesc}>
            {lt('cdb_forgot_password_expired_desc')}
          </p>

          <div className={styles.action}>
            <Button className="title-semiBold" onClick={handleResend}>
              {lt('cdb_forgot_password_resend')}
            </Button>
          </div>
        </div>
      </main>
    </LoginBasicBox>
  );
};

export default LinkExpired;
